// Fog of war for the map: which 8x8-tile cells a character has seen. Both sides run the same rule:
// the server keeps (and saves) the mask, the client mirrors it from its own position as it moves.
import { MAP_H, MAP_W, TILE } from './content.ts';

export const EXPLORE_CELL = 8; // tiles per cell side
export const EXPLORE_W = MAP_W / EXPLORE_CELL;
export const EXPLORE_H = MAP_H / EXPLORE_CELL;
/** How far you see, in cells (a little past the edge of the screen). */
export const EXPLORE_R = 3;

export const newExplored = (): Uint8Array => new Uint8Array((EXPLORE_W * EXPLORE_H) / 8);

export const isExplored = (m: Uint8Array, cx: number, cy: number): boolean => (m[(cy * EXPLORE_W + cx) >> 3] & (1 << ((cy * EXPLORE_W + cx) & 7))) !== 0;

/** Mark the cells around a world position (pixels). Returns true if anything was new. */
export function markExplored(m: Uint8Array, x: number, y: number): boolean {
  const ccx = Math.floor(x / TILE / EXPLORE_CELL), ccy = Math.floor(y / TILE / EXPLORE_CELL);
  let changed = false;
  for (let cy = ccy - EXPLORE_R; cy <= ccy + EXPLORE_R; cy++) {
    for (let cx = ccx - EXPLORE_R; cx <= ccx + EXPLORE_R; cx++) {
      if (cx < 0 || cy < 0 || cx >= EXPLORE_W || cy >= EXPLORE_H) continue;
      const dx = cx - ccx, dy = cy - ccy;
      if (dx * dx + dy * dy > EXPLORE_R * EXPLORE_R + 1) continue;
      const i = cy * EXPLORE_W + cx;
      if (m[i >> 3] & (1 << (i & 7))) continue;
      m[i >> 3] |= 1 << (i & 7);
      changed = true;
    }
  }
  return changed;
}

export const encodeExplored = (m: Uint8Array): string => btoa(String.fromCharCode(...m));
export function decodeExplored(s: string | null | undefined): Uint8Array {
  const m = newExplored();
  if (!s) return m;
  try {
    const raw = atob(s);
    for (let i = 0; i < Math.min(raw.length, m.length); i++) m[i] = raw.charCodeAt(i);
  } catch {
    // a broken mask just starts over
  }
  return m;
}
